export const CID_KEY = "$cid";
